// import React from 'react';

// import Html from "../Assets/img/html.svg";
// import Next from "../Assets/img/next.svg";
// import Redux from "../Assets/img/redux.svg";
// import Typescript from "../Assets/img/typescript.svg";
// import Tailwind from "../Assets/img/tailwind.svg";
// import Rest from "../Assets/img/restapi.svg";
// import Graphql from "../Assets/img/graphql.svg";
// import Git from "../Assets/img/git.svg";
// import Github from "../Assets/img/github.svg";
// import Jira from "../Assets/img/jira.svg";
// import Css from "../Assets/img/css.svg";
// import JavaScript from "../Assets/img/javascript.png";
// import ReactLogo from "../Assets/img/reactlogo.png";
// import Node from "../Assets/img/nodejs.svg";
// import Express from "../Assets/img/express.svg";
// import Mongodb from "../Assets/img/mongodb.svg";
// import Mysql from "../Assets/img/mysql.svg";
// import Jest from "../Assets/img/Jest.svg";
// import ReactTesting from "../Assets/img/ReactTestingLibrary.svg";
// import AWS from "../Assets/img/aws.svg";
// import openai from "../Assets/img/openai.svg";
// import Cypress from "../Assets/img/cypress.svg";
// import Vitest from "../Assets/img/vitest.svg";
// import Docker from "../Assets/img/docker.png";
// import GitHubAction from "../Assets/img/GitHub_action.png";

// const Skills = () => {
//     return (
//         <>
//             <div className="sectionContainer">
//                 <h1 className="sectionName">SKILLS</h1>
//                 <h1 className="sectionHeadline">Summary of my technical skills 💻</h1>
//                 <div className="skillsContainer">
//                     {/* Group 1 */}
//                     <div className="skillGroup">
//                         <div className="eachTech">
//                             <span className="tooltip">HTML5</span>
//                             <img src={Html} alt="HTML Tech" />
//                         </div>
//                         <div className="eachTech">
//                             <span className="tooltip">CSS3</span>
//                             <img src={Css} alt="CSS Tech" />
//                         </div>
//                         <div className="eachTech">
//                             <span className="tooltip">JavaScript</span>
//                             <img src={JavaScript} alt="JavaScript Tech" />
//                         </div>
//                         <div className="eachTech">
//                             <span className="tooltip">React Js</span>
//                             <img src={ReactLogo} alt="React Tech" />
//                         </div>
//                         <div className="eachTech">
//                             <span className="tooltip">Next Js</span>
//                             <img src={Next} alt="Next Tech" />
//                         </div>
//                     </div>

//                     {/* Group 2 */}
//                     <div className="skillGroup">
//                         <div className="eachTech">
//                             <span className="tooltip">Redux</span>
//                             <img src={Redux} alt="Redux Tech" />
//                         </div>
//                         <div className="eachTech">
//                             <span className="tooltip">TypeScript</span>
//                             <img src={Typescript} alt="TypeScript Tech" />
//                         </div>
//                         <div className="eachTech">
//                             <span className="tooltip">TailwindCSS</span>
//                             <img src={Tailwind} alt="TailwindCSS Tech" />
//                         </div>
//                         <div className="eachTech">
//                             <span className="tooltip">Restful API</span>
//                             <img src={Rest} alt="Restful API Tech" />
//                         </div>
//                         <div className="eachTech">
//                             <span className="tooltip">GraphQL</span>
//                             <img src={Graphql} alt="GraphQL Tech" />
//                         </div>
//                     </div>

//                     {/* Group 3 */}
//                     <div className="skillGroup">
//                         <div className="eachTech">
//                             <span className="tooltip">Node js</span>
//                             <img src={Node} alt="Node Tech" />
//                         </div>
//                         <div className="eachTech">
//                             <span className="tooltip">Express js</span>
//                             <img src={Express} alt="Express Tech" />
//                         </div>
//                         <div className="eachTech">
//                             <span className="tooltip">MongoDB</span>
//                             <img src={Mongodb} alt="MongoDB Tech" />
//                         </div>
//                         <div className="eachTech">
//                             <span className="tooltip">MySQL</span>
//                             <img src={Mysql} alt="MySQL Tech" />
//                         </div>
//                         <div className="eachTech">
//                             <span className="tooltip">Cypress</span>
//                             <img src={Cypress} alt="Cypress Tech" />
//                         </div>
//                     </div>

//                     {/* Group 4 */}
//                     <div className="skillGroup">
//                         <div className="eachTech">
//                             <span className="tooltip">Jest</span>
//                             <img src={Jest} alt="Jest Tech" />
//                         </div>
//                         <div className="eachTech">
//                             <span className="tooltip">Git</span>
//                             <img src={Git} alt="Git Tech" />
//                         </div>
//                         <div className="eachTech">
//                             <span className="tooltip">React Testing Library</span>
//                             <img src={ReactTesting} alt="React Testing Library" />
//                         </div>
//                         <div className="eachTech">
//                             <span className="tooltip">GitHub</span>
//                             <img src={Github} alt="GitHub Tech" />
//                         </div>
//                         <div className="eachTech">
//                             <span className="tooltip">Vitest</span>
//                             <img src={Vitest} alt="Vitest Tech" />
//                         </div>
//                     </div>

//                     {/* Group 5 */}
//                     <div className="skillGroup">
//                         <div className="eachTech">
//                             <span className="tooltip">AWS</span>
//                             <img src={AWS} alt="AWS Tech" />
//                         </div>
//                         <div className="eachTech">
//                             <span className="tooltip">openai</span>
//                             <img src={openai} alt="openai Action" />
//                         </div>
//                         <div className="eachTech">
//                             <span className="tooltip">GitHub Action</span>
//                             <img src={GitHubAction} alt="GitHub Action" />
//                         </div>
//                         <div className="eachTech">
//                             <span className="tooltip">Docker</span>
//                             <img src={Docker} alt="Docker Tech" />
//                         </div>
//                         <div className="eachTech">
//                             <span className="tooltip">Jira</span>
//                             <img src={Jira} alt="Jira Tech" />
//                         </div>
//                     </div>

//                 </div>
//             </div>
//         </>
//     );
// };

// export default Skills;

import React from 'react';

import Next from '../Assets/img/next.svg';
import Typescript from '../Assets/img/typescript.svg';
import Tailwind from '../Assets/img/tailwind.svg';
import Rest from '../Assets/img/restapi.svg';
import Graphql from '../Assets/img/graphql.svg';
import Git from '../Assets/img/git.svg';
import Github from '../Assets/img/github.svg';
import JavaScript from '../Assets/img/javascript.png';
import ReactLogo from '../Assets/img/reactlogo.png';
import Node from '../Assets/img/nodejs.svg';
import Express from '../Assets/img/express.svg';
import Mongodb from '../Assets/img/mongodb.svg';
import Mysql from '../Assets/img/mysql.svg';
import Postgresql from '../Assets/img/postgresql.svg';
import Nestjs from '../Assets/img/nestjs.svg';
import Typeorm from '../Assets/img/typeorm.svg';
import Prisma from '../Assets/img/prisma.svg';
import Jest from '../Assets/img/Jest.svg';
import ReactTesting from '../Assets/img/ReactTestingLibrary.svg';
import AWS from '../Assets/img/aws.svg';
import openai from '../Assets/img/openai.svg';
import Cypress from '../Assets/img/cypress.svg';
import Vitest from '../Assets/img/vitest.svg';
import Docker from '../Assets/img/docker.png';
import GitHubAction from '../Assets/img/GitHub_action.png';

const Skills = () => {
  return (
    <>
      <div className="sectionContainer">
        <h1 className="sectionName">SKILLS</h1>
        <h1 className="sectionHeadline">Summary of my technical skills 💻</h1>

        <div className="skillsContainer">
          {/* Group 1 - Frontend */}
          <div className="skillGroup">
            <div className="eachTech">
              <span className="tooltip">React.js</span>
              <img src={ReactLogo} alt="React.js" />
            </div>

            <div className="eachTech">
              <span className="tooltip">Next.js</span>
              <img src={Next} alt="Next.js" />
            </div>

            <div className="eachTech">
              <span className="tooltip">TypeScript</span>
              <img src={Typescript} alt="TypeScript" />
            </div>

            <div className="eachTech">
              <span className="tooltip">JavaScript</span>
              <img src={JavaScript} alt="JavaScript" />
            </div>

            <div className="eachTech">
              <span className="tooltip">Tailwind CSS</span>
              <img src={Tailwind} alt="Tailwind CSS" />
            </div>
          </div>

          {/* Group 2 - Backend & APIs */}
          <div className="skillGroup">
            <div className="eachTech">
              <span className="tooltip">Node.js</span>
              <img src={Node} alt="Node.js" />
            </div>

            <div className="eachTech">
              <span className="tooltip">NestJS</span>
              <img src={Nestjs} alt="NestJS" />
            </div>

            <div className="eachTech">
              <span className="tooltip">Express.js</span>
              <img src={Express} alt="Express.js" />
            </div>

            <div className="eachTech">
              <span className="tooltip">REST APIs</span>
              <img src={Rest} alt="REST APIs" />
            </div>

            <div className="eachTech">
              <span className="tooltip">GraphQL</span>
              <img src={Graphql} alt="GraphQL" />
            </div>
          </div>

          {/* Group 3 - Databases & ORM */}
          <div className="skillGroup">
            <div className="eachTech">
              <span className="tooltip">PostgreSQL</span>
              <img src={Postgresql} alt="PostgreSQL" />
            </div>

            <div className="eachTech">
              <span className="tooltip">MySQL</span>
              <img src={Mysql} alt="MySQL" />
            </div>

            <div className="eachTech">
              <span className="tooltip">MongoDB</span>
              <img src={Mongodb} alt="MongoDB" />
            </div>

            <div className="eachTech">
              <span className="tooltip">TypeORM</span>
              <img src={Typeorm} alt="TypeORM" />
            </div>

            <div className="eachTech">
              <span className="tooltip">Prisma</span>
              <img src={Prisma} alt="Prisma" />
            </div>
          </div>

          {/* Group 4 - AI & Testing */}
          <div className="skillGroup">
            <div className="eachTech">
              <span className="tooltip">OpenAI API</span>
              <img src={openai} alt="OpenAI API" />
            </div>

            <div className="eachTech">
              <span className="tooltip">Jest</span>
              <img src={Jest} alt="Jest" />
            </div>

            <div className="eachTech">
              <span className="tooltip">React Testing Library</span>
              <img src={ReactTesting} alt="React Testing Library" />
            </div>

            <div className="eachTech">
              <span className="tooltip">Vitest</span>
              <img src={Vitest} alt="Vitest" />
            </div>

            <div className="eachTech">
              <span className="tooltip">Cypress</span>
              <img src={Cypress} alt="Cypress" />
            </div>
          </div>

          {/* Group 5 - Cloud, DevOps & Tools */}
          <div className="skillGroup">
            <div className="eachTech">
              <span className="tooltip">AWS</span>
              <img src={AWS} alt="AWS" />
            </div>

            <div className="eachTech">
              <span className="tooltip">Docker</span>
              <img src={Docker} alt="Docker" />
            </div>

            <div className="eachTech">
              <span className="tooltip">GitHub Actions</span>
              <img src={GitHubAction} alt="GitHub Actions" />
            </div>

            <div className="eachTech">
              <span className="tooltip">Git</span>
              <img src={Git} alt="Git" />
            </div>

            <div className="eachTech">
              <span className="tooltip">GitHub</span>
              <img src={Github} alt="GitHub" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Skills;
